import { BATCH_DELETE_SHORTCUTS_LOADING } from "~/store/action_types";
import {
  ADD_SHORTCUT_SUCCESS,
  DELETE_SHORTCUT_SUCCESS,
  FETCH_SHORTCUTS_SUCCESS,
  REORDER_SHORTCUTS_LOADING,
} from "~/store/action_types";

const shortcuts = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SHORTCUTS_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { shortcuts = {} } = entities;
      return shortcuts;
    }
    case ADD_SHORTCUT_SUCCESS: {
      const { response = {} } = action;
      const { entities = {} } = response;
      const { shortcuts = {} } = entities;
      return { ...state, ...shortcuts };
    }
    case DELETE_SHORTCUT_SUCCESS: {
      const { id = 0 } = action;

      if (id > 0) {
        delete state[id];
        return { ...state };
      }

      return state;
    }
    case BATCH_DELETE_SHORTCUTS_LOADING: {
      const { ids } = action;

      if (ids) {
        ids.forEach((id) => {
          delete state[id];
        });
        return { ...state };
      }

      return state;
    }
    case REORDER_SHORTCUTS_LOADING: {
      const { order = [] } = action;

      if (order.length > 0) {
        const newShortcutOrder = { ...state };

        const positionMap = Object.values(newShortcutOrder).reduce((acc, { id, position }) => {
          acc[position] = id;
          return acc;
        }, {});

        order.forEach(({ source, target }) => {
          const sourcePos = newShortcutOrder[source].position;
          const targetPos = newShortcutOrder[target].position;
          const ltr = sourcePos > targetPos;

          let min = ltr ? targetPos : sourcePos + 1;
          let max = ltr ? sourcePos - 1 : targetPos;

          let targetIds = [];
          for (let i = min; i <= max; i++) {
            const id = positionMap[i];
            if (!id) continue;
            targetIds.push(id);
          }
          if (ltr) {
            targetIds = [source, ...targetIds];
          } else {
            targetIds = [...targetIds, source];
          }
          let nextPosition = ltr ? targetPos : sourcePos;
          targetIds.forEach((targetId) => {
            positionMap[nextPosition] = targetId;
            newShortcutOrder[targetId].position = nextPosition++;
          });
        });

        return newShortcutOrder;
      }

      return state;
    }
    default:
      return state;
  }
};

export default shortcuts;
